import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";

import { ActionData } from "./types";
import React from "react";

interface StatisticsCardsProps {
  actions: ActionData[];
  isLoading: boolean;
}

const StatisticsCards: React.FC<StatisticsCardsProps> = ({
  actions,
  isLoading,
}) => {
  const cardStyles = {
    minWidth: 180,
    flex: 1,
    borderRadius: 1,
    overflow: "hidden",
  };

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 3 }}>
      <Card elevation={1} sx={cardStyles}>
        <CardContent>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ fontSize: "0.7rem" }}
          >
            Total Actions
          </Typography>
          <Typography variant="h4" fontWeight="bold" color="primary.main">
            {isLoading ? <CircularProgress size={24} /> : actions.length}
          </Typography>
        </CardContent>
      </Card>

      <Card elevation={1} sx={cardStyles}>
        <CardContent>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ fontSize: "0.7rem" }}
          >
            Completed
          </Typography>
          <Typography variant="h4" fontWeight="bold" color="success.main">
            {isLoading ? (
              <CircularProgress size={24} />
            ) : (
              actions.filter((a) => a.status?.toLowerCase() === "completed")
                .length
            )}
          </Typography>
        </CardContent>
      </Card>

      <Card elevation={1} sx={cardStyles}>
        <CardContent>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ fontSize: "0.7rem" }}
          >
            Pending
          </Typography>
          <Typography variant="h4" fontWeight="bold" color="warning.main">
            {isLoading ? (
              <CircularProgress size={24} />
            ) : (
              actions.filter((a) => a.status?.toLowerCase() === "pending")
                .length
            )}
          </Typography>
        </CardContent>
      </Card>

      <Card elevation={1} sx={cardStyles}>
        <CardContent>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ fontSize: "0.7rem" }}
          >
            Failed
          </Typography>
          <Typography variant="h4" fontWeight="bold" color="error.main">
            {isLoading ? (
              <CircularProgress size={24} />
            ) : (
              actions.filter((a) => a.status?.toLowerCase() === "failed").length
            )}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default StatisticsCards;
